import { module } from './store'
import { StorefrontModule } from '@vue-storefront/core/lib/modules'

export const KEY = 'giftCertificate'

export const GiftCertificate: StorefrontModule = function ({ store }) {
  store.registerModule(KEY, module)
}
